/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */
import { createAction, props } from '@ngrx/store';
import { ReasonCode } from '../model/reason-code';
export const fetchReasonCodes = createAction('[User] Fetch Reason Codes');
export const fetchReasonCodesSuccess = createAction('[User] Fetch Reason Codes Success', props<{ reasonCodes: ReasonCode[] }>());
export const fetchReasonCodesFail = createAction('[User] Fetch Reason Codes Fail', props<{ payload: string }>());
